var _excluded = ["rows"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import SurfaceOrg from "../SurfaceOrg";
import RowMol from "./RowMol";
function FlexibleTableOrg(_ref) {
  var rows = _ref.rows,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(SurfaceOrg, _extends({
    spacingSpace: {
      vertical: 3,
      horizontal: 4
    },
    color: onColor === "backgroundLight" ? "background" : "backgroundLight",
    shadow: "small",
    hasBorder: true,
    borderWidth: 1
  }, restProps), rows.map(function (row, rowIndex) {
    return /*#__PURE__*/React.createElement(RowMol
    // eslint-disable-next-line react/no-array-index-key
    , {
      key: "Row-".concat(rowIndex),
      row: row
    });
  }));
}
export default FlexibleTableOrg;